export default "__VITE_ASSET__Cea9ggmk__"